import React, { useState, useCallback, useMemo } from 'react';
import { Typography, Divider, Paper, Grid, Box, Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import VendorSelect from 'components/vendorSelect';
import { getSubscriptions } from 'services/subscriptions';
import VendorLibraries from 'components/vendorLibraries';

const SubscriptionsPage = () => {

  const gridStyle = useMemo(() => ({ minHeight: 480, width: '100%' }), []);
  const [ pageFilters, setPageFilters] = React.useState({});

  const [subscriptions, setSubscriptions] = useState([]);
  const { enqueueSnackbar } = useSnackbar();


  // const defaultFilterValue = [
  //   { name: 'Property', operator: 'contains', type: 'string', value: '' },
  //   { name: 'Vendor', operator: 'contains', type: 'string', value: '' },
  //   { name: 'description', operator: 'contains', type: 'string', value: '' },
  //   { name: 'Amount', operator: 'contains', type: 'string', value: '' },
  //   { name: 'createdOn', operator: 'contains', type: 'string', value: '' },
  // ];

  const columns = useMemo(() => ([
    { name: 'userType', header: 'User Type', width: 200},
    { name: 'propertyType', header: 'Property Type', width: 280},
    { name: 'name', header: 'Name', width: 280},
    { name: 'amount', header: 'Amount', width: 120},
    { name: 'validFrom', header: 'Valid From', width: 180},
    { name: 'validTill', header: 'Valid Till', width: 180},
    { name: 'createdOn', header: 'Date', width: 120},
  ]),[]);

  // useEffect(() => {
  //  if(pageFilters?.filterDates && pageFilters?.vendor && pageFilters?.library){
  //   getIncentivesData()
  //  }
  // }, [pageFilters]);

  function getSubscriptionsData() {
    const propertyId= pageFilters.library.id;
    const userId= pageFilters.vendor.userId;
    getSubscriptions({propertyId, userId}).then(({response, error}) => {
      if(response){
        setSubscriptions(response);
      } else {
        setSubscriptions([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const onLibrarySelected = useCallback((library) => {
    if(pageFilters?.library?.id !== library?.id){
      setPageFilters({...pageFilters, library});
    }
  }, [pageFilters]);

  const onVendorSelected = useCallback((vendor) => {
    if(pageFilters?.vendor?.userId !== vendor?.userId){
      setPageFilters({...pageFilters, vendor});
    }
  }, [pageFilters]);

  function onGoBtnClick() {
    if(!(pageFilters?.vendor)){
      enqueueSnackbar("Select vendor", {variant: 'error'});
      return;
    }
    if(!(pageFilters?.library)){
      enqueueSnackbar("Select library", {variant: 'error'});
      return;
    }
    getSubscriptionsData();
  }

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Subscriptions
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container>
          <Grid container item xs={12} sm={12} md={12} xl={12} lg={12} sx={{p:1, bgcolor: "#f3f3f3"}}>
            <Typography variant="subtitle2" gutterBottom component="div">
              Filters
            </Typography>
            <Grid container item xs={12} sm={12} md={12} xl={12} lg={12} >
              <Grid item sx={{pt: 2,  pl:1}} xs={12} sm={5} md={5} xl={3} lg={4}>
                <VendorSelect onVendorSelected={onVendorSelected}/>
              </Grid>
              <Grid item sx={{pt: 2, pl:1}} xs={12} sm={5} md={5} xl={3} lg={4}>
                <VendorLibraries onLibrarySelected={onLibrarySelected} variant="outlined" vendorId={pageFilters?.vendor?.userId} />
              </Grid>
              <Grid item sx={{pt: 2,  pl:1}} xs={2} sm={2} md={2} xl={2} lg={2}>
                <Button variant="contained" onClick={onGoBtnClick} sx={{textTransform:'none', fontSize: 14, py: '7px'}}>Go</Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} >
            <Box component="div" sx={{  mt: 3 ,  maxHeight: 720, width: '100%' }}>
              <ReactDataGrid
                // handle={setGridRef}
                idProperty="index"
                style={gridStyle}
                // defaultFilterValue={defaultFilterValue}
                columns={columns}
                dataSource={subscriptions}
                rowHeight={null} 
                minRowHeight={50}
              />
            </Box>
          </Grid>
        </Grid>
      </Box> 
    </Paper>
  );
}
 
export default SubscriptionsPage;
